export interface MetricsState {
  metrics: GaMetric[]
  currentKeyMetrics: KeyMetrics[]
}

export const initialState = {
  metrics: [],
  currentKeyMetrics: [],
}

export const metrics = (
  state: MetricsState = initialState,
  action: ReduxAction,
): MetricsState => {
  switch (action.type) {
    case 'GET_GA_METRICS':
      return {
        ...state,
        metrics: action.payload,
      }
    // case 'PRESET_CURRENT_KEY_METRICS': {
    //   return {
    //     ...state,
    //     currentKeyMetrics: state.currentKeyMetrics.concat([
    //       {
    //         apiName: action.payload.newMetric,
    //         displayName: action.payload.newMetricName,
    //         metricSetup: false,
    //       },
    //     ]),
    //   }
    // }
    case 'GET_CURRENT_KEY_METRICS':
      return {
        ...state,
        currentKeyMetrics: action.payload.metrics,
      }
    default:
      return state
  }
}
